import fromPairs from 'lodash/fp/fromPairs'

export const MAXIMUM: string = 'newsbrief_count'
export const MINIMUM: string = 'minimum_newsbrief_count'
export const MAXIMUM_PREFERRED: string = 'max_preferred_count'
export const MAXIMUM_LEAD: string = 'max_lead_count'
export const MAXIMUM_PER_SOURCE: string = 'max_per_source'

export const CATEGORY_MAXIMUM_PREFIX: string = 'newsbrief_count_'
export const CATEGORY_MINIMUM_PREFIX: string = 'minimum_newsbrief_count_'
export const CATEGORY_MAXIMUM_PREFERRED_PREFIX: string = 'max_preferred_count_'
export const CATEGORY_MAXIMUM_LEAD_PREFIX: string = 'max_lead_count_'
export const CATEGORY_MAXIMUM_PER_SOURCE_PREFIX: string = 'max_per_source_'

const ALL_COUNT_PREFIXES = [
  CATEGORY_MAXIMUM_PREFIX,
  CATEGORY_MINIMUM_PREFIX,
  CATEGORY_MAXIMUM_PREFERRED_PREFIX,
  CATEGORY_MAXIMUM_LEAD_PREFIX,
  CATEGORY_MAXIMUM_PER_SOURCE_PREFIX,
]

export const ALL_CONTENT_KEYS: string[] = [
  MAXIMUM,
  MINIMUM,
  MAXIMUM_PREFERRED,
  MAXIMUM_LEAD,
  MAXIMUM_PER_SOURCE,
]

export const categoryKeys = (categoryName: string): string[] => {
  const lowerCaseName = categoryName.toLowerCase()
  if (lowerCaseName === 'content') {
    return ALL_CONTENT_KEYS
  } else {
    return ALL_COUNT_PREFIXES.map((s: string) => s + lowerCaseName)
  }
}

export const UPDATE_NEWSBRIEF_COUNT = 'UPDATE_NEWSBRIEF_COUNT'
export const ADD_NEWSBRIEF_COUNT = 'ADD_NEWSBRIEF_COUNT'

interface CountDict {
  helpKey: string,
  key: string,
  label: string,
}

const LABEL_LIST: CountDict[] = [
  {helpKey: 'newsbrief-counts-' + MAXIMUM, key: MAXIMUM, label: 'Maximum'},
  {helpKey: 'newsbrief-counts-' + MINIMUM, key: MINIMUM, label: 'Minimum'},
  {helpKey: 'newsbrief-counts-' + MAXIMUM_PREFERRED, key: MAXIMUM_PREFERRED, label: 'Max Preferred'},
  {helpKey: 'newsbrief-counts-' + MAXIMUM_LEAD, key: MAXIMUM_LEAD, label: 'Max Lead'},
  {helpKey: 'newsbrief-counts-' + MAXIMUM_PER_SOURCE, key: MAXIMUM_PER_SOURCE, label: 'Max Per Source'},
]
export const LABELS: {[key: string]: CountDict} = fromPairs(LABEL_LIST.map((c: CountDict) => [c.key, c]))



// WEBPACK FOOTER //
// ./src/pages/newsbrief/counts/constants.ts